import React, {useEffect, useRef} from 'react';
import ReduxToastr, {toastr} from 'react-redux-toastr';
import {useDispatch, useSelector} from 'react-redux';
import { Sidebar, Sticky } from 'semantic-ui-react';
import { isMenuVisible } from './components/NavBottomBar/reducer';
import { closeMenu } from './components/NavBottomBar/actions';
import NavTopBar from './components/NavTopBar';
import NavBottomBar from './components/NavBottomBar';
import SideMenu from './views/SideMenu';
import {useNotification} from "./components/Notification";
import { ConfigProvider } from 'antd';


import './App.css';
import {MIXPANEL_API_KEY} from "./config/secrets";
import {isSearchVisible} from "./components/NavTopBar/reducer";
import {closeSearch} from "./components/NavTopBar/actions";

import {store} from "./configureStore";
import {useLocation, useNavigate} from "react-router-dom";
import {getAuthToken, getUserData, getUserLoggedIn} from "./components/UserLogin/reducer";
import {getLocationData} from "./components/GeoLocation/reducer";
import {isArray} from "lodash";
import {fetchProducts, PRODUCTS_PAGE_COUNT} from "./views/Products/actions";

import {getLanguage, setLanguage} from "./components/LanguageModal/reducer";

import mixpanel from 'mixpanel-browser';
import {setTypeExhibition} from "./views/Home/actions";
import {getTypeExhibition} from "./views/Home/reducer";
import search from "./components/Search";
import {getFilterState} from "./views/Exponents/reducer";

const MIXPANEL_TOKEN = MIXPANEL_API_KEY;
const MIXPANEL_CONFIG = {
  debug: true,
  track_pageview: true,
  persistence: 'localStorage'
};
mixpanel.init(MIXPANEL_TOKEN, MIXPANEL_CONFIG);

export const Base64= {_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

//const publicVapidKey = process.env.PUBLIC_VAPID_KEY;

// проверяем поддерживаются ли web push уведомления
export function checkNotificationSupported() {
  return new Promise((fulfilled, reject) => {
    if (!('serviceWorker' in navigator)) {
      reject(new Error('Service workers are not supported by this browser'));
      return;
    }

    if (!('PushManager' in window)) {
      reject(new Error('Push notifications are not supported by this browser'));
      return;
    }

    if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
      reject(new Error('Notifications are not supported by this browser'));
      return;
    }

    fulfilled();
  })
}

function App (props) {

  const router = useSelector((state) => state.router);
  const language = useSelector(getLanguage);
  const languageString = language[0]+language[1];
  const location = useLocation();

  const typeExhibition = useSelector(state => getTypeExhibition(state.exhibition));
  const isModalOpen = useSelector((state) => getFilterState(state.exponents));

  const dataExhibition = {
    asia: {
      color: '#B10000',
    },
    gras: {
      color: '#037C00',
    }
  }

  const { contextHolder } = useNotification();

  const defaultProps = {
    navigate: useNavigate(),
    dispatch: useDispatch(),
    searchVisible: useSelector((state) => isSearchVisible(state.navtopbar)),
    menuVisible: useSelector((state) => isMenuVisible(state.navbottombar)),
    userData: useSelector((state) => getUserData(state.userLogin)),
    userLocation: useSelector((state) => getLocationData(state.userLocation)),
    isLoggedIn: useSelector((state) => getUserLoggedIn(state.userLogin)),
    token: useSelector((state) => getAuthToken(state.userLogin)),
    mixpanel,
    routeAction: router.action,
    location: router.location,
    previousLocations: router.previousLocations,
    isPageReloaded: router.action === 'POP' && isArray(router.previousLocations) && _.size(router.previousLocations) === 1,
  }
  const {children} = props;
  const {routeAction, previousLocations, menuVisible, searchVisible, dispatch} = defaultProps;

  if ( process.env.REACT_APP_ENV !== 'production') {
    console.log('App - глобальные стейты REDUX', store.getState());
    console.log('App - router-redux action, location, previous', routeAction, location, previousLocations);
  }

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    let expo = search.get("expo");
    let lang = search.get("lang");

    if (!expo && location.hash.includes("?")) {
      const hashQuery = location.hash.split("?")[1];
      const params = new URLSearchParams(`?${hashQuery}`);
      expo = params.get("expo");
      lang = params.get("lang");
    }

    if (expo === 'asia' || expo === 'gras') {
      if (typeExhibition !== expo) {
        dispatch(setTypeExhibition({ type: expo }));
      }
    }

    if (lang === 'ru' || lang === 'en') {
      if (languageString !== lang) {
        dispatch(setLanguage(lang));
      }
    }
  }, [location.search, location.hash, typeExhibition, languageString, dispatch]);

  function hideBars () {
    if (menuVisible)
      dispatch(closeMenu());

    if (searchVisible)
      dispatch(closeSearch());
  }

  useEffect(() => {
    dispatch(fetchProducts({
      page: 1,
      per_page: PRODUCTS_PAGE_COUNT,
      order: 'asc',
      orderby: 'id',
      lang: languageString,
    }));
  }, [languageString, dispatch]);

  /* ------------------------------------------------------------------------------------------------------------- */
  return (
      <div>
        <ReduxToastr
            timeOut={4000}
            newestOnTop
            preventDuplicates
            position="top-center"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
        />
        <NavTopBar {...defaultProps}/>
        <Sidebar.Pushable style={{transform: 'none'}}>
          <Sticky>
            <SideMenu {...defaultProps}/>
          </Sticky>
          <Sidebar.Pusher
              dimmed={menuVisible || searchVisible || isModalOpen}
              onClick={hideBars}
              style={{minHeight: '100vh'}}
          >
            {children}
            <ConfigProvider theme={{token: {colorPrimary: dataExhibition[typeExhibition].color}}}>
              {!location.pathname.startsWith('/profile') &&
                  !location.pathname.startsWith('/asiameet') &&
                  !location.pathname.startsWith('/scan') &&
                  contextHolder}
            </ConfigProvider>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        <NavBottomBar {...defaultProps}/>
      </div>
  );
}

export default App;